import { ImageLoader } from './image-loader';
import { initResponsiveTables } from './app-global/app-tables';
import { itinerarySliderImageSwap } from 'components/shared/slides/itinerarySlider';

declare global {
	var assetPath: string;
	var iconSheet: string;
	var usingTemplateLoader: boolean | undefined;
	var imageLoader: ImageLoader;
}

const init = async () => {
	globalThis.imageLoader = new ImageLoader();
	globalThis.imageLoader.initialize();

	initResponsiveTables();

	document.body.style.setProperty('--check-image', `url(${assetPath}/icon/checkmark.svg)`);

	const currentYear = new Date().getFullYear().toString();
	document.querySelectorAll('time.current-year')
		.forEach((e: HTMLTimeElement) => {
			e.textContent = currentYear;
		});

	const getStaggeredItems = (staggerContainer: HTMLElement): ReadonlyArray<HTMLElement> =>
		[...staggerContainer.children].flatMap((child: HTMLElement) => {
			if (child.classList.contains('stagger-contents'))
				return getStaggeredItems(child);
			return child;
		});
	document.querySelectorAll('.stagger-container').forEach((container: HTMLElement) => {
		getStaggeredItems(container).forEach((item, i) => {
			item.style.setProperty('--stagger-index', i + '');
		});
	});

	const showNicelyObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const intersectingOrAbove =
				entry.intersectionRatio > 0.7 ||
				entry.intersectionRect.height > 150 ||
				entry.boundingClientRect.bottom <= 0;
			const element = entry.target;
			element.classList.toggle('show-later', !intersectingOrAbove);
			if (intersectingOrAbove) {
				showNicelyObserver.unobserve(element);
				element.classList.add('showing');
				element.dispatchEvent(new CustomEvent('showingNicely'));
			}
		});
	}, {
		threshold: [0, 0.25, 0.5, 0.75, 1]
	});
	document.querySelectorAll('.show-nicely').forEach(element => {
		showNicelyObserver.observe(element);
	});
	
	itinerarySliderImageSwap();





	function addInViewClass(selectors) {
		const elements = document.querySelectorAll(selectors);

		if(window.innerWidth < 768) {
			elements.forEach(el => el.classList.add('in-view'));
		} else {
			const observer = new IntersectionObserver((entries) => {
			  entries.forEach(entry => {
				if (entry.isIntersecting) {
				  entry.target.classList.add('in-view');
				} else {
				  entry.target.classList.remove('in-view');
				}
			  });
			}, {
			  threshold: 0.1
			});
		  
			elements.forEach(el => observer.observe(el));
		}
	  }
	  
	  addInViewClass('.grid-cards__wrap.animated, .grid-cards__wrap.animated .grid-cards__heading, .grid-cards__wrap.animated .cards-title, .grid-cards__wrap.animated .grid-cards__cards .grid-card__row');

	// Tabbed Content
	const tabBtns = document.querySelectorAll('.tab-content__container .nav-link');
	const tabPanes = document.querySelectorAll('.tab-content .tab-pane');

	function activateTab(index: number) {
		if(tabBtns && tabPanes && tabBtns.length > index && tabPanes.length > index) {
			tabBtns.forEach((tabBtn) => {
				tabBtn.classList.remove('active');
				tabBtn.setAttribute('aria-selected', 'false');
			});
			tabPanes.forEach((pane) => {
				pane.classList.remove('active');
			});

			tabBtns[index].classList.add('active');
			tabBtns[index].setAttribute('aria-selected', 'true');
	
			tabPanes[index].classList.add('active');
		}
	}

	tabBtns.forEach((tabBtn, index) => {
		tabBtn.addEventListener('click', () => {
			activateTab(index);
		});
	});

	if(tabBtns) {
		activateTab(0);
	}

	//Service Charts
	const serviceChartWrappers = document.querySelectorAll(".services-chart-wrapper");
	if(serviceChartWrappers){
		serviceChartWrappers.forEach((el) => {
			const toggleButton = el.querySelector(".chart-key-toggle");
			const closeButton = el.querySelector(".close-chart-key");
			if(toggleButton){
				toggleButton.addEventListener("click", () => {
					const chartKeyOverlay = toggleButton.parentNode?.parentNode?.querySelector(".chart-key-overlay");
					chartKeyOverlay?.classList.add("show");
				})
			}
			if(closeButton){
				closeButton.addEventListener("click", () => {
					const chartKeyOverlay = closeButton.parentNode?.parentNode?.parentNode as HTMLElement;
					chartKeyOverlay?.classList.remove("show")
				})
			}

			const chartKeyOverlay = el.querySelector(".chart-key-overlay");
			chartKeyOverlay?.addEventListener("click", () => {
				chartKeyOverlay?.classList.remove("show");
			})

			//Handle Tooltips
			const tooltips = el.querySelectorAll(".tooltip");
			tooltips.forEach((tooltip) => {
				const tooltipContent = tooltip.querySelector(".tooltip-content");
				tooltipContent?.addEventListener("click", () => {
					(tooltipContent as HTMLElement).classList.add("hide");
					setTimeout(() => {
						(tooltipContent as HTMLElement).classList.remove("hide");
					}, 500)
				})
			})
		})
	};

	// Footer copy routing number 
	const copyBtn = document.getElementById('copy-btn-footer')!;
	function copyRoutingnumber() {
		const copyBtn = document.getElementById('copy-btn-footer')!;
		const routingNumber = document.getElementById('routing-number-footer')!;
		const copyFeedback = document.getElementById('copy-feedback-footer')!;

		copyBtn.addEventListener('click', () => {
			navigator.clipboard.writeText(routingNumber.textContent || '')
			.then(() => {
				copyFeedback.classList.remove('hidden');
				setTimeout(() => {
					copyFeedback.classList.add('hidden');
				}, 2000);
			})
			.catch(err => {
				console.error('Failed to copy text: ', err);
			});
		});
	};
	if(copyBtn) {
		copyRoutingnumber();
	}

	const header = document.getElementById('header');
	if (header) {
		new ResizeObserver(() => {
			document.documentElement.style.setProperty(
			'--header-height',
			header.getBoundingClientRect().height + 'px'
			);
		}).observe(header);
	}

	// Rec Vehicle Loan Widget(desktop)
	const categoryLinks = document.querySelectorAll('.categories a');
	function categoryLinkClick () {
		const categoryLinks = document.querySelectorAll('.categories a');
		if(categoryLinks) {
			const boatDivs = document.querySelectorAll<HTMLElement>('.boat');
			const rvDivs = document.querySelectorAll<HTMLElement>('.rv');
			const bikeDivs = document.querySelectorAll<HTMLElement>('.motorcycle');
			const otherDivs = document.querySelectorAll<HTMLElement>('.other');
	
			categoryLinks.forEach((link) => {
				link.addEventListener('click', ()=> {

					boatDivs.forEach((div) => div.classList.remove('show'));
					rvDivs.forEach((div) => div.classList.remove('show'));
					bikeDivs.forEach((div) => div.classList.remove('show'));
					otherDivs.forEach((div) => div.classList.remove('show'));


					if(link.classList.contains('boat-link')) {
						boatDivs.forEach((div) => {
							div.classList.add('show');
						});
					} else if(link.classList.contains('rv-link')) {
						rvDivs.forEach((div) => {
							div.classList.add('show');
						});
					} else if(link.classList.contains('motorcycle-link')) {
						bikeDivs.forEach((div) => {
							div.classList.add('show');
						});
					} else if(link.classList.contains('other-link')) {
						otherDivs.forEach((div) => {
							div.classList.add('show');
						});
					}
					
				});
				
			});
		}
	}
	if(categoryLinks) {
		categoryLinkClick();
	}
	// Rec Vehicle Dropdown(mobile)
	const dropdown = document.querySelector('.rec-vehicle__dropdown') as HTMLSelectElement;
	const mobileBtn = document.querySelector('.rec-vehicle__select-ctas .btn');
	
	function mobileBtnClick(){

		if(dropdown && mobileBtn) {

			mobileBtn.addEventListener('click', (e)=> {
				e.preventDefault();
	
				const selectedValue = dropdown.value;

				dropdown.querySelectorAll('option').forEach(option => {
					if (option.value === selectedValue) {
						option.setAttribute('aria-selected', 'true');
					} else {
						option.setAttribute('aria-selected', 'false');
					}
				});
	
				document.querySelectorAll('.show').forEach(el => {
					el.classList.remove('show');
				});
	
				if(selectedValue) {
					const elementsToShow = document.querySelectorAll(`.${selectedValue}`);
					elementsToShow.forEach(el => {
						el.classList.add('show');
					});
				}
			});
		};
	}
	if(mobileBtn && dropdown) {
		mobileBtnClick();
	}


	// Tooltips for Compare Grid
		const tooltips = document.querySelectorAll(".tooltip");
		tooltips.forEach((tooltip) => {

			const tooltipBtn = tooltip.querySelector(".tooltip-toggle-button") as HTMLElement;

			if(tooltipBtn) {

				tooltipBtn.onclick = () => {
					tooltipBtn.focus();
					tooltip.classList.add('show');
				};

				tooltipBtn.onblur = () => {
					tooltipBtn.blur();
					tooltip.classList.remove('show');
				};

				tooltipBtn.onkeyup = (e) => {
					if(e.code === 'Enter' || e.which === 13) {
						e.preventDefault();
						tooltip.classList.add('show')
					}
				};
				tooltipBtn.ontouchstart = () => {
					tooltipBtn.focus();
					tooltipBtn.classList.add('show');
				}
				tooltipBtn.ontouchend = () => {
					tooltipBtn.blur();
					tooltipBtn.classList.remove('show');
				}
			};
		});

	
	// State Panel Selector/Filter
	const stateSelector = document.getElementById('state-selector') as HTMLSelectElement;
	function stateSelectorFilter() {
		const statePanels: Record<string, HTMLElement | null> = {
			"michigan": document.getElementById('michigan') as HTMLElement,
			"arkansas": document.getElementById('arkansas') as HTMLElement,
			"indiana": document.getElementById('indiana') as HTMLElement,
			"nevada": document.getElementById('nevada') as HTMLElement,
			"northcarolina": document.getElementById('northcarolina') as HTMLElement,
			"ohio": document.getElementById('ohio') as HTMLElement,
			"oklahoma": document.getElementById('oklahoma') as HTMLElement,
			"pennsylvania": document.getElementById('pennsylvania') as HTMLElement,
			"other": document.getElementById('other') as HTMLElement
		};
	
		// Hide all panels initially...
		Object.values(statePanels).forEach(panel => {
			if(panel) {
				panel.style.display = 'none'
				panel.setAttribute('aria-selected', 'false');
			}
		});

		// Set Michigan by default
		if (statePanels["michigan"]) {
			statePanels["michigan"].style.display = 'block';
			statePanels["michigan"].setAttribute('aria-selected', 'true');
			stateSelector.value = 'michigan'
		}
	
		let currentPanel: HTMLElement | null = statePanels["michigan"];
	
		stateSelector.addEventListener('change', () => {
			const options = Array.from(stateSelector.options);
			options.forEach(option => option.setAttribute("aria-selected", "false"));

			const selectedOption = stateSelector.selectedOptions[0];
			selectedOption.setAttribute("aria-selected", "true");
	
			const selectedValue = stateSelector.value;
			const nextPanel = statePanels[selectedValue] || statePanels["other"];
	
			if (currentPanel !== nextPanel) {
				if(currentPanel) {
					currentPanel.style.display = 'none';
					currentPanel.setAttribute('aria-selected', 'false');
				}
				if(nextPanel) {
					nextPanel.style.display = 'block';
					nextPanel.setAttribute('aria-selected', 'true');
				}
				currentPanel = nextPanel;
			}
		});
	}
	if(stateSelector) {
		stateSelectorFilter();
	}
};

export default async () => {
	if (globalThis.usingTemplateLoader)
		addEventListener('templateLoaded', init);
	else {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				init()
			});
		} else {
			init()
		}
	}
	// OLB login
    (function() {
        const toggle = document.querySelector<HTMLElement>('.olb__trigger');
        const panel = document.querySelector<HTMLElement>('.olb');
		const mobileCloseBtn = document.querySelector<HTMLElement>('.mobile-login-close');

        if (!toggle || !panel) {
            return;
        }

		toggle.onclick = () => {
			panel.classList.toggle('active');
			const isActive = panel.classList.contains('active');
			window.dispatchEvent(new CustomEvent('olbToggle', { detail: { isActive } }));
		};

		toggle.onkeyup = (e) => {
			if (e.code === 'Enter' || e.which === 13) {
				e.preventDefault();
				panel.classList.toggle('active');
				const isActive = panel.classList.contains('active');
				window.dispatchEvent(new CustomEvent('olbToggle', { detail: { isActive } }));
			}
		};

		if(mobileCloseBtn){
			mobileCloseBtn.onclick = () => {
				panel.classList.remove('active');
				window.dispatchEvent(new  CustomEvent('olbToggle', {detail: { isActive: false}}));
			}
		}
    })();

    globalThis.closeOlb = function() {
        const panel = document.querySelector<HTMLElement>('.olb');

        if (!panel) {
            return;
        }
        panel.classList.remove('active');
		window.dispatchEvent(new  CustomEvent('olbToggle', {detail: { isActive: false}}));
    };
};
